// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609021304/js/" + chunkId + "." + {"44":"902a465e","225":"512e9c59","481":"06f49276","486":"0dfa0b3a","770":"ddb50eea"}[chunkId] + ".0.7085144213625759.chunk.js";
};